import React, { Component } from 'react';
import { Link } from 'react-router-dom'
class CollectionSidebarElement extends Component {
    state = {  }
    render() { 
    let { title , numberOfFiles , id, fetchCollections } = this.props
        return (        
                <div className="flex justify-between text-gray-400 mt-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" /></svg>
                <span onClick={()=>fetchCollections(id)} className="ml-2 cursor-pointer flex hover:text-wvrOrange active:text-wvrOrange">{title}</span>
                <div className="">
                <span className="ml-1 text-wvrOrange rounded-full font-bold">{numberOfFiles}</span>
                </div>
                </div>
         );
    }
}
 
export default CollectionSidebarElement;